import React, { useMemo } from 'react';
import { CopilotQuestionList } from './CopilotQuestionList';
import useAISmartTableData from '../../Home/hooks/useAISmartTableData';
import { CopilotGreeting } from './CopilotGreeting';
import ChatSmartTable from '../../ChatSmartTable';
import './AiTableTabContent.scss';

interface IAiTableTabContentProps {
  onClickRecommend: (value: string) => void;
  /** DS 报告模板信息 */
  dsReport?: {
    show?: boolean;
    id?: string;
    document_id?: string;
    name?: string;
    [key: string]: unknown;
  };
  /** 会话 ID */
  sessionId?: string;
  /** 更新 DS 报告回调 */
  handleUpdateDsReport?: (update: { show?: boolean; [key: string]: unknown; }) => void;
  /** 开始新对话回调 */
  startNewConversation?: (...args: any[]) => void;
  /** 对话列表 */
  conversations?: unknown[];
  /** 流式状态 */
  streamingState?: string;
  /** 只读模式 */
  readonly?: boolean;
  /** 聚焦回调 */
  onFocus?: () => void;
  /** 标题栏鼠标按下回调 */
  onHeaderMouseDown?: (e: React.MouseEvent) => void;
}

export const AiTableTabContent: React.FC<IAiTableTabContentProps> = ({
  onClickRecommend,
  dsReport,
  sessionId,
  handleUpdateDsReport,
  startNewConversation,
  conversations,
  streamingState,
  readonly = false,
  onFocus,
  onHeaderMouseDown,
}) => {
  const { aiTableRecommendData, loading: aiTableLoading } = useAISmartTableData();

  const aiTableQuestions = useMemo(() => {
    return aiTableRecommendData?.flatMap((category: any) =>
      (category.data || category.recommendQuestions || []).map((q: any) => ({
        name: q.questionEn || q.name,
        name_cn: q.questionCn || q.name_cn,
      }))
    ) || [];
  }, [aiTableRecommendData]);

  // 判断是否有有效的 dsReport 数据（兼容 id 和 document_id）
  const reportId = dsReport?.document_id || dsReport?.id;
  const hasValidReport = !!(dsReport?.show && reportId);

  // 如果有有效的报告数据，直接渲染 ChatSmartTable
  if (hasValidReport && handleUpdateDsReport && sessionId && startNewConversation) {
    return (
      <div className="dba-ai-table-tab-content">
        <ChatSmartTable
          dsReport={dsReport}
          sessionId={sessionId}
          handleUpdateDsReport={handleUpdateDsReport}
          startNewConversation={startNewConversation as any}
          conversations={conversations}
          streamingState={streamingState}
          readonly={readonly}
          onFocus={onFocus}
          onHeaderMouseDown={onHeaderMouseDown}
        />
      </div>
    );
  }

  // 否则显示推荐问题
  return (
    <>
      <CopilotGreeting tab="aiExcel" />
      <CopilotQuestionList
        data={aiTableQuestions}
        loading={aiTableLoading}
        batchSize={2}
        handleClickRecommend={onClickRecommend}
      />
    </>
  );
};
